<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive } from "vue";
import { checkBegriff } from "@/local";
import { mountedBase, BaseSetup, onSave } from "@/DataLoaderStatic";
import { goBack } from "@/NavigationHelper";

import {
  createEditorValidator,
  provideEditorValidator,
} from "@/components/EditorValidator";
import { showSnackbar } from "@/UIHelper";
let showZeitzone = ref<boolean>(false);
const validator = createEditorValidator();
provideEditorValidator(validator);

const emit = defineEmits<{
  back: [];
}>();

const pageParams: DataPageParameter = {
  backOnSave: true,
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "Web_TimeLineStempelungen",
  bewegungsdaten: true,
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  uiData.showLoading = true;
  const zeitzone = checkBegriff("PZE_Web_Zeitzone_Nacherfassen");
  if (zeitzone) {
    showZeitzone.value = true;
  }
  await mountedBase(uiData, pageParams);
  uiData.showLoading = false;
  uiData.initialized = true;
});

async function onValidate() {
  return await validator.validateAsync();
}
async function save() {
  const isvalid = await onValidate();
  if (!isvalid.valid) {
    showSnackbar({
      text:
        "Validierung fehlgeschlagen - Bitte prüfen! (" +
        isvalid.invalidFields.join(", ") +
        ")",
      duration: 4000,
      color: "error",
    });
    return;
  }
  await onSave(uiData, pageParams, 0);

  goBack();
}
</script>
<template>
  <v-card :loading="uiData.showLoading">
    <v-card-text v-if="uiData.initialized" class="pa-2">
      <EditTimePicker kennung="PHYS_ZEITPUNKT" />
      <EditComboBox v-if="showZeitzone" kennung="BEW_ZEITZONE" />
      <EditTextArea :auto-grow="true" kennung="MEMO" />
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <CommonBaseButtons
        :backVisible="false"
        :deleteVisible="false"
        :createVisible="false"
        :refreshVisible="false"
        :saveVisible="true"
        @back="goBack()"
        @save="save"
      ></CommonBaseButtons>
    </v-card-actions>
  </v-card>
</template>
